import React, { FC, useEffect, useRef, useState } from "react";
import classNames from "classnames";

// Types
import { AppointmentInformationDto } from "@apiModels/AppointmentInformationDto.csharp";

// Components
import { FormAppointmentDetails } from "../../BookingLegacy/FormAppointmentDetails/FormAppointmentDetails";
import { PracticalInformation } from "../../BookingLegacy/PracticalInformation/PracticalInformation";
import { CenterInformation } from "../../BookingLegacy/CenterInformation/CenterInformation";
import { FAQAccordion } from "../../BookingLegacy/FAQAccordion/FAQAccordion";
import { AppointmentCancellationConfirmationModal } from "../AppointmentCancellationConfirmationModal";

// Helpers
import { Errors } from "../Errors";
import { StepThreeParams } from "../../../Pages/MyAppointment/Steps/StepThreeParams.csharp";

interface StepThreeProps extends StepThreeParams {
  cancelAppointment: () => void;
  exit: () => void;
  appointmentInformation: AppointmentInformationDto;
  apiErrors: string[];
  isLoading: boolean;
  Modal: any;
}

export const AppointmentPanelStep: FC<StepThreeProps> = ({
  exitButtonText,
  cancelAppointmentModal,
  cancelButtonText,
  content,
  title,
  cancelAppointment,
  appointmentInformation,
  exit,
  apiErrors,
  isLoading,
  Modal,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    Modal.setAppElement(wrapperRef.current!);
  }, []);

  const { cancellationEnabled, message: cancellationMessage } =
    appointmentInformation.cancellationDeadlineDto;

  const enableCancellation = cancellationEnabled && apiErrors.length == 0;

  const {
    doctor,
    location,
    appointment,
    service,
    specialization,
    bookingResponse,
    pricingSummary,
  } = appointmentInformation;

  return (
    <>
      <div className="d-flex justify-content-center mt-1 mb-3">
        <div className="d-flex flex-column">
          <h1 className="mb-3 mb-md-4 text-center">{title}</h1>
        </div>
      </div>
      <div className="mb-4">
        <div className="mb-3">
          <div dangerouslySetInnerHTML={{ __html: content }} />
          <FormAppointmentDetails
            doctor={doctor}
            center={location}
            appointment={appointment}
            service={service}
            specialization={specialization}
            displayHeading={false}
            pricingSummary={pricingSummary}
            cancellationMessage={cancellationMessage}
            modal={Modal}
          />
          <PracticalInformation
            bookingResponse={bookingResponse}
            service={service}
            specialization={specialization}
            isWaitlist={false}
            hideGeneralInfo
          />
          <CenterInformation
            centerName={location.name}
            bookingResponse={bookingResponse}
          />
          <FAQAccordion extendWings />
          <Errors errors={apiErrors} />
        </div>
        <div className="mt-3 d-flex flex-column accordion-faq accordion-faq--extended">
          <button
            className={classNames("btn btn-primary mb-1 me-2 w-100", {
              disabled: !enableCancellation,
            })}
            onClick={() => setIsModalOpen(true)}
          >
            {cancelButtonText}
          </button>
          <button className="btn btn-light  mb-1 w-100" onClick={exit}>
            {exitButtonText}
          </button>
        </div>
      </div>
      <AppointmentCancellationConfirmationModal
        Modal={Modal}
        isOpen={isModalOpen}
        modalContent={cancelAppointmentModal}
        onSubmit={cancelAppointment}
        onClose={() => setIsModalOpen(false)}
        isLoading={isLoading}
      />
    </>
  );
};
